module.exports = __webpack_public_path__ + "img/image6.1b0a3102.jpg";